export const DEFAULT_INACTIVE_PERIOD = 30*60*1000;
export const DEFAULT_INACTIVE_THROTTLE = 10*1000;